/**
 * "Learn Medsender" tutorial actions.
 *
 * Plain action creators in the style of actions/modal.js — the tutorial engine
 * needs no API calls of its own. Persisting the `has_completed_tutorial`
 * summary flag reuses updateUserDetails from actions/userProfile.js, exactly as
 * the walkthrough persists its own fields.
 */

export const openTutorialMenu = () => (dispatch) => {
  dispatch({ type: 'OPEN_TUTORIAL_MENU' });
};

export const closeTutorialMenu = () => (dispatch) => {
  dispatch({ type: 'CLOSE_TUTORIAL_MENU' });
};

export const startTutorial = (tutorialId) => (dispatch) => {
  dispatch({ type: 'START_TUTORIAL', tutorialId });
};

/**
 * Asks for a tutorial to be launched from a surface that can't do it itself.
 * The Guide page lists the tutorials but has no router/target awareness, so it
 * records the request and LearnMedsender (mounted app-wide) performs the real
 * navigate-then-start sequence.
 */
export const requestTutorial = (tutorialId) => (dispatch) => {
  dispatch({ type: 'REQUEST_TUTORIAL', tutorialId });
};

export const clearPendingTutorial = () => (dispatch) => {
  dispatch({ type: 'CLEAR_PENDING_TUTORIAL' });
};

/** Exit/skip: leaves the tutorial without recording completion. */
export const stopTutorial = () => (dispatch) => {
  dispatch({ type: 'STOP_TUTORIAL' });
};

/** A tutorial ran to its last step. */
export const finishTutorial = ({ reopenMenu = true } = {}) => (dispatch) => {
  dispatch({ type: 'TUTORIAL_FINISHED', reopenMenu });
};

export const markAutoOpenEvaluated = () => (dispatch) => {
  dispatch({ type: 'TUTORIAL_AUTO_OPEN_EVALUATED' });
};
